import { Hero } from "@/components/layout/Hero";
import { Section } from "@/components/layout/Section";
import { useRouter } from "next/router";
import React from "react";

export const ReadyToBecomeVIPSection: React.FC = () => {
  const router = useRouter();
  return (
    <Section>
      <Hero
        header="Ready to Become a VIP?"
        tagline="Join Visionary Meals' exclusive VIP service! Enjoy savings on healthy, locally-sourced meals, rotating monthly to bring you delicious, seasonal cuisines. Embrace a world of culinary delights while benefiting from our loyalty rewards."
        buttons={[
          {
            label: "Sign-Up Now",
            onClick: () => {
              router.push("/vip");
            },
          },
        ]}
        backgroundRaw="linear-gradient(90deg, #94E7CE 0%, #FFFFFF 100%)"
      />
    </Section>
  );
};
